import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'

export default function Footer() {
  return (
    <>
      <div className='bg_footer md:h-[900px] h-[250px] relative bg-[#040F1A]'>
        <div class='lg:px-20 md:px-10 px-5   absolute -bottom-20 bg-[#040F1A] '>
          <footer class='md:block hidden px-5 bg-[#040F1A]'>
            <div class='grid lg:grid-cols-2 grid-cols-1 md:gap-14 gap-8  pb-5'>
              <div class=''>
                <div>
                  <AnimateOnScroll animation='flipIn'>
                    <p class=''>
                      An innovative blockchain trading assistant designed to
                      elevate your trading experience.
                    </p>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <p class=' mt-5'>
                      Copyright © 2024 Tools AI. All Rights Reserved
                    </p>
                  </AnimateOnScroll>
                </div>
              </div>
              <div>
                <div class='grid md:grid-cols-3 grid-cols-2 gap-5'>
                  <div>
                    <AnimateOnScroll animation='flipIn'>
                      <h3 class='text-[20px] font-semibold'>Quick Links</h3>
                    </AnimateOnScroll>
                    <ul class='flex flex-col gap-3 mt-3'>
                      <AnimateOnScroll animation='flipIn'>
                        <li>
                          <a
                            href='#about'
                            class='nav-item'
                          >
                            <p>About</p>
                          </a>
                        </li>
                      </AnimateOnScroll>
                      <AnimateOnScroll animation='flipIn'>
                        <li>
                          <a
                            href='#utilities'
                            class='nav-item'
                          >
                            <p>Utilities</p>
                          </a>
                        </li>
                      </AnimateOnScroll>
                      <AnimateOnScroll animation='flipIn'>
                        <li>
                          <a
                            href='#benefits'
                            class='nav-item'
                          >
                            <p>Benefits</p>
                          </a>
                        </li>
                      </AnimateOnScroll>
                      <AnimateOnScroll animation='flipIn'>
                        <li>
                          <a
                            href='#revenuesharing'
                            class='nav-item'
                          >
                            <p>Revenue Sharing</p>
                          </a>
                        </li>
                      </AnimateOnScroll>
                      <AnimateOnScroll animation='flipIn'>
                        <li>
                          <a
                            href='#tokenomics'
                            class='nav-item'
                          >
                            <p>Tokenomics</p>
                          </a>
                        </li>
                      </AnimateOnScroll>
                      <AnimateOnScroll animation='flipIn'>
                        <li>
                          <a
                            href='#features'
                            class='nav-item'
                          >
                            <p>Features</p>
                          </a>
                        </li>
                      </AnimateOnScroll>
                      <AnimateOnScroll animation='flipIn'>
                        <li>
                          <a
                            href='#roadmap'
                            class='nav-item'
                          >
                            <p>Roadmap</p>
                          </a>
                        </li>
                      </AnimateOnScroll>
                    </ul>
                  </div>
                  <div>
                    <AnimateOnScroll animation='flipIn'>
                      <h3 class='text-[20px] font-semibold'>Resources</h3>
                    </AnimateOnScroll>
                    <ul class='flex flex-col gap-3 mt-3'>
                      <AnimateOnScroll animation='flipIn'>
                        <li>
                          <a
                            href=' '
                            class='nav-item'
                          >
                            <p>Whitepaper </p>
                          </a>
                        </li>
                      </AnimateOnScroll>
                      <AnimateOnScroll animation='flipIn'>
                        <li>
                          <a
                            href=' '
                            class='nav-item'
                          >
                            <p>Telegram Bot</p>
                          </a>
                        </li>
                      </AnimateOnScroll>
                    </ul>
                  </div>
                  <div>
                    <AnimateOnScroll animation='flipIn'>
                      <h3 class='text-[20px] font-semibold'>SOCIALS</h3>
                    </AnimateOnScroll>
                    <div class='flex items-center gap-0 mt-3'>
                      <AnimateOnScroll animation='flipIn'>
                        <a
                          href=''
                          class=' nav-item'
                        >
                          <img
                            src='/images/telegram.png'
                            alt='telegram'
                            class=' w-[40px] h-[40px]'
                          />
                        </a>
                      </AnimateOnScroll>
                      <AnimateOnScroll animation='flipIn'>
                        <a
                          href=' '
                          class=' nav-item'
                        >
                          <img
                            src='/images/twitter.png'
                            alt='twitter'
                            class=' w-[40px] h-[40px]'
                          />
                        </a>
                      </AnimateOnScroll>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>

      <footer class='md:hidden block px-5 bg-[#040F1A]'>
        <div class='grid lg:grid-cols-2 grid-cols-1 md:gap-14 gap-8  pb-5'>
          <div class=''>
            <div>
              <AnimateOnScroll animation='flipIn'>
                <p class=''>
                  An innovative blockchain trading assistant designed to elevate
                  your trading experience.
                </p>
              </AnimateOnScroll>
              <AnimateOnScroll animation='flipIn'>
                <p class=' mt-5'>
                  Copyright © 2024 Tools AI. All Rights Reserved
                </p>
              </AnimateOnScroll>
            </div>
          </div>
          <div>
            <div class='grid md:grid-cols-3 grid-cols-2 gap-5'>
              <div>
                <AnimateOnScroll animation='flipIn'>
                  <h3 class='text-[20px] font-semibold'>Quick Links</h3>
                </AnimateOnScroll>
                <ul class='flex flex-col gap-3 mt-3'>
                  <AnimateOnScroll animation='flipIn'>
                    <li>
                      <a
                        href='#about'
                        class='nav-item'
                      >
                        <p>About</p>
                      </a>
                    </li>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <li>
                      <a
                        href='#utilities'
                        class='nav-item'
                      >
                        <p>Utilities</p>
                      </a>
                    </li>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <li>
                      <a
                        href='#benefits'
                        class='nav-item'
                      >
                        <p>Benefits</p>
                      </a>
                    </li>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <li>
                      <a
                        href='#revenuesharing'
                        class='nav-item'
                      >
                        <p>Revenue Sharing</p>
                      </a>
                    </li>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <li>
                      <a
                        href='#tokenomics'
                        class='nav-item'
                      >
                        <p>Tokenomics</p>
                      </a>
                    </li>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <li>
                      <a
                        href='#features'
                        class='nav-item'
                      >
                        <p>Features</p>
                      </a>
                    </li>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <li>
                      <a
                        href='#roadmap'
                        class='nav-item'
                      >
                        <p>Roadmap</p>
                      </a>
                    </li>
                  </AnimateOnScroll>
                </ul>
              </div>
              <div>
                <AnimateOnScroll animation='flipIn'>
                  <h3 class='text-[20px] font-semibold'>Resources</h3>
                </AnimateOnScroll>
                <ul class='flex flex-col gap-3 mt-3'>
                  <AnimateOnScroll animation='flipIn'>
                    <li>
                      <a
                        href=' '
                        class='nav-item'
                      >
                        <p>Whitepaper </p>
                      </a>
                    </li>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <li>
                      <a
                        href=' '
                        class='nav-item'
                      >
                        <p>Telegram Bot</p>
                      </a>
                    </li>
                  </AnimateOnScroll>
                </ul>
              </div>
              <div>
                <AnimateOnScroll animation='flipIn'>
                  <h3 class='text-[20px] font-semibold'>SOCIALS</h3>
                </AnimateOnScroll>
                <div class='flex items-center gap-2 mt-3'>
                  <AnimateOnScroll animation='flipIn'>
                    <a
                      href=''
                      class='zoom nav-item'
                    >
                      <img
                        src='/images/telegram.png'
                        alt='telegram'
                        class=' w-[40px] h-[40px]'
                      />
                    </a>
                  </AnimateOnScroll>
                  <AnimateOnScroll animation='flipIn'>
                    <a
                      href=' '
                      class='zoom nav-item'
                    >
                      <img
                        src='/images/twitter.png'
                        alt='twitter'
                        class=' w-[40px] h-[40px]'
                      />
                    </a>
                  </AnimateOnScroll>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
